(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/divider/assets/javascripts/divider.js') >= 0) return;  svs.modules.push('/widgets/divider/assets/javascripts/divider.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.divider = svs.widget.divider || {};
  svs.widget.divider.init = svs.content.divider.init;
})(svs);

 })(window);